/* eslint-disable no-unused-vars */
export default (context, inject) => {
  const util = {
    colorCode: (str) => {
      let i,c,a;
      let r = 0; let g = 0; let b = 0;
      for (i = 0; i < str.length; i++) {
        c = str.charCodeAt(i);
        const h = 22.5 * (c % 16); const s = 0.1*(c/16) + 0.3; const v = 1.0;
        const h_i = Math.floor(h/60.0);
        const f = (h/60.0) - h_i;
        const p = v*(1-s); const q = v*(1-f*s); const  t = v*(1-(1-f)*s);
        const rgb = [[v,t,p],[q,v,p],[p,v,t],[p,q,v],[t,q,v],[v,p,q]];
        const r2 = ~~(255*(rgb[h_i][0])); const g2 = ~~(255*(rgb[h_i][1])); const b2 = ~~(255*(rgb[h_i][2]));
        a = [r2, g2, b2];
        r += a[0]; g += a[1]; b += a[2];
      }
      r = ~~(r / str.length);
      g = ~~(g / str.length);
      b = ~~(b / str.length);
      return '#' + [r,g,b].map(function(i) {
        const val = i.toString(16);
        return i < 16 ? "0" + val : val
      }).join('');
    },
    setIsOpen: (status) => {
      window.$nuxt.$emit('setIsOpen', status)
    },
    message: async (messages) => {
      await context.store.commit('setMessages', messages)
      await window.$nuxt.$emit('setMessages')
      window.$nuxt.$emit('showToast')
    },
    errorHandling: (response) => {
      if (response.status === 500) {
        context.app.$util.message([{status: 'danger', title: 'エラー', desc: 'サーバーエラーが発生しました。'}])
      }
      if (response.status === 401 || response.status === 419) {
        context.app.$util.message([{status: 'danger', title: 'エラー', desc: '認証エラーが発生しました。'}])
        context.app.store.dispatch('setUser', {})
        if (context.route.path !== '/login/' && context.route.path !== '/reset-password/' && context.route.path !== '/reset-email/') {
          context.app.router.replace({ path: '/login/' })
        }
      }
      if (response.status === 404) {
        context.app.$util.message([{status: 'danger', title: 'エラー', desc: 'APIが見つかりません。'}])
      }
      let hasErrors = false
      Object.keys(response.data).forEach( key => {
        if (key === 'errors') {
          hasErrors = true
        }
      })
      const errors = {}
      if (hasErrors) {
        Object.keys(response.data.errors).forEach( key => {
          errors[key] = response.data.errors[key].join("\n")
        })
      }
      return errors
    },
    countStrBytes: (str) => {
      let length = 0
      if (str === null) {
        return length;
      }
      for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i)
        if (code <= 0x007F) {
          length += 1;
        } else {
          length += 2;
        }
      }
      return length;
    }
  }
  inject('util', util)
}